import { useState } from 'react';
import { Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { useAddDriverToBoardMutation } from '../../../features/Dispatch/DispatchSlice';
import errorHandler from '../../hooks/ErrorHanlder';

const AddActiveDriver = (props) => {
    const [addDriverToBoard] = useAddDriverToBoardMutation();
    const [selectedDriver, setSelectedDriver] = useState("");

    const addToBoard = async (e) => {
        try {
            await addDriverToBoard({ divisionID: props.divisionId, driverNumber: e.target.value }).unwrap();
            toast.success("Driver added to board successfully", {
                position: "top-center",
            })
            props.fetchDrivers(props.divisionId);
            setSelectedDriver("");
        } catch (error) {
            errorHandler(error);
        }
    }

    return (
        <fieldset className=' mt-3 main-driver-container mb-2'>
            <label htmlFor="" className='label-heading '>Add Driver/Agent/Interliner/Division to the Boards</label>
            <div className="driver-container">
                <div className="w-75">
                    <Form.Group controlId="Roletype">
                        <Form.Select
                            aria-label="Floating label select example"
                            name="Role"
                            value={selectedDriver}
                            onChange={async (e) => {
                                setSelectedDriver(e.target.value);
                                await addToBoard(e);
                                props.getDriverList(props.divisionId)
                            }}>
                            <option value="">Select Driver/Agent/Interliner/Division</option>
                            <>
                                {
                                    !props.divisionId || props.divisionId === '' ? [] :
                                    props.driverListResult?.data?.data?.map((data, index) => (
                                        <option key={index} value={data?.driverNumber}>{data?.driverNumber + " " + data?.name}</option>
                                    ))
                                }
                            </>
                        </Form.Select>

                    </Form.Group>
                </div>
            </div>
        </fieldset>
    )
}

export default AddActiveDriver
